

var _validFileExtensions = [".jpg", ".jpeg", ".bmp", ".gif", ".png"];
imageFormat

const imageFormat = (fileType) => {
  const extIndex = fileType.type.lastIndexOf('/') + 1;
 var fileExtension= fileType.type.substr(extIndex).split('.')[0];
 if(fileExtension ==='jpg'|| fileExtension ==='jpeg'||
 fileExtension ==='bmp'|| fileExtension ==='gif'|| fileExtension ==='png')
 {
   return true;
 }
};


const getFileExt=function (oForm) {
    var arrInputs = oForm.getElementsByTagName("input");
    for (var i = 0; i < arrInputs.length; i++) {
        var oInput = arrInputs[i];
        if (oInput.type == "file") {
            var sFileName = oInput.value;
            if (sFileName.length > 0) {
                var blnValid = false;
                for (var j = 0; j < _validFileExtensions.length; j++) {
                    var sCurExtension = _validFileExtensions[j];
                    if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                        blnValid = true;
                        break;
                    }
                }

                if (!blnValid) {
                    alert("Sorry, " + sFileName + " is invalid, allowed extensions are: " + _validFileExtensions.join(", "));
                    return false;
                }
            }
        }
    }

    return true;
}

export default imageFormat;
